var React = require('react');

function NewOrder (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"12","y1":"5","x2":"12","y2":"19","key":0}),React.createElement("line",{"x1":"5","y1":"12","x2":"19","y2":"12","key":1})]);
}

NewOrder.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = NewOrder;

NewOrder.default = NewOrder;
